import { Injectable } from '@angular/core';

import { UserAuthenticationBaseStrategy } from './user-authentication-base-strategy';

@Injectable()
export class PhonePasswordStrategy extends UserAuthenticationBaseStrategy {
  // TODO: Implement the relevant functions for phone password authentication
}
